import React, { useEffect } from "react";
import { useSnackbar } from "notistack";
import { useSelector, useDispatch } from "react-redux";
import { hideSnackBarNotifications, hideError } from "actions";

const AUTO_HIDE_MS = 4000;

const NotificationToaster = () => {
  const dispatch = useDispatch();
  const commonState = useSelector((state) => state.commonState);
  const session = useSelector((state) => state.session);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    const message = commonState.snackbar_notification;
    const type = commonState.snackbar_notification_type;

    if (!message) return undefined;

    let variant = null;
    if (type === "general_error" || type === "token_expire") {
      variant = "error";
    } else if (type === "success") {
      variant = "success";
    }

    if (!variant) return undefined;

    const key = enqueueSnackbar(message, {
      variant,
      autoHideDuration: AUTO_HIDE_MS,
      disableWindowBlurListener: true,
      onClose: () => {
        dispatch(hideSnackBarNotifications(type));
        dispatch(hideError());
      },
    });

    const timer = setTimeout(() => {
      closeSnackbar(key);
      dispatch(hideSnackBarNotifications(type));
      dispatch(hideError());
    }, AUTO_HIDE_MS);

    return () => {
      clearTimeout(timer);
    };
  }, [
    commonState.snackbar_notification,
    commonState.snackbar_notification_type,
    closeSnackbar,
    dispatch,
    enqueueSnackbar,
  ]);

  useEffect(() => {
    const message = session.error;
    const type = session.error_type;

    if (!message) return undefined;

    let variant = null;
    if (type === "general") {
      variant = "error";
    } else if (type === "message") {
      variant = "success";
    }

    if (!variant) return undefined;

    const key = enqueueSnackbar(message, {
      variant,
      autoHideDuration: AUTO_HIDE_MS,
      disableWindowBlurListener: true,
      onClose: () => {
        dispatch(hideError());
      },
    });

    const timer = setTimeout(() => {
      closeSnackbar(key);
      dispatch(hideError());
    }, AUTO_HIDE_MS);

    return () => {
      clearTimeout(timer);
    };
  }, [session.error, session.error_type, closeSnackbar, dispatch, enqueueSnackbar]);

  return null;
};

export default NotificationToaster;
